/**
 * เลือกภาษาให้ชื่อ/คำอธิบายที่ API ส่งมาเป็น "คู่" — `name` (ไทย) + `name_en` (อังกฤษ optional)
 *
 * API ไม่แปลให้ ส่งมาทั้งสองคีย์แล้วให้ FE เลือกตอน render
 * ข้อดีคือสลับภาษาแล้วเปลี่ยนทันทีแบบ reactive ไม่ต้อง refetch/reload
 *
 * ใช้ในเทมเพลตผ่าน global property `$ln`:
 *   {{ $ln(product) }}                  → product.name / product.name_en
 *   {{ $ln(product, 'category') }}      → product.category / product.category_en
 *   {{ $ln(item, 'product_name') }}     → item.product_name / item.product_name_en
 *
 * ใช้ใน <script> (นอก render) ผ่าน pickLocalized(obj, this.$i18n.locale, field)
 *
 * ⚠️ ค่าอังกฤษว่าง = fallback ไปไทยเสมอ จึงไม่มีทางคืนค่าว่างถ้าไทยมีค่า
 *    และ object ที่ไม่มีคู่ `_en` (เช่น ชื่อสาขา/หน่วยนับ/วัตถุดิบ) ก็ยังคืนค่าเดิมได้ปกติ
 */
export function pickLocalized(obj, locale, field = 'name') {
  if (!obj) return '';

  const base = obj[field] ?? '';
  if (locale !== 'en') return base;

  const english = obj[`${field}_en`];
  return (english === undefined || english === null || english === '') ? base : english;
}

export default {
  install(app) {
    // ประกาศเป็น function ปกติ (ไม่ใช่ arrow) เพื่อให้ `this` เป็น component instance
    // → อ่าน this.$i18n.locale ได้ และ render จะ track reactivity ของ locale ให้เอง
    app.config.globalProperties.$ln = function (obj, field = 'name') {
      const value = pickLocalized(obj, this.$i18n.locale, field);
      // ส่งต่อผ่าน $t อีกชั้นเพื่อคงพฤติกรรมเดิมของหน้าจอที่เคยเขียน $t(product.name)
      // (ชื่อที่เคยใส่ไว้ใน dictionary ยังแปลได้ ถ้าไม่มีคีย์ $t ก็คืนค่าเดิม)
      return value ? this.$t(value) : '';
    };
  }
};
